module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04i-red-LED-sequence.116b7d48.png";